module.exports = __webpack_public_path__ + "img/4-8158.fef1ed78.png";